(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp_upsell_items"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.variant-form').forEach(async form => {
      const productId = form.dataset.productId;
      const variants = JSON.parse(document.getElementById(`variants-${productId}`).textContent);
      const selects = form.querySelectorAll('.variant-option');
      let variantIdInput = form.querySelector('.variant-id-input');
      const imageEl = form.querySelector('.variant-img');

      function updateVariant() {
        const selectedOptions = Array.from(selects).map(select => select.value);
        const matched = variants.find(v => v.available && v.options.every((opt, idx) => opt === selectedOptions[idx]));

        if (matched) {
          variantIdInput.value = matched.id;
          if (matched.featured_image && imageEl) {
            imageEl.src = matched.featured_image.src.replace(/(\.jpg|\.png|\.webp)(\?.*)?$/, '_300x$1');
          }
        }
      }

      selects.forEach(select => {
        select.addEventListener('change', updateVariant);
      });

      updateVariant(); // set default

      form.addEventListener('submit', async function(e) {
        e.preventDefault();

        const variantId = variantIdInput.value;

// Use Minimog's built-in Ajax cart system (FoxKit)
        await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(
            {id: variantId, quantity: 1}
          )
        }).then((t) => t.json()).then(response => {
          console.log(response);
          if (window.MinimogSettings && window.MinimogSettings.use_ajax_atc) {
            window.REFRESH_CART();
            setTimeout(function() {
              window.OPEN_CART();
            }, 1000);
          }
        }).catch(err => {
          console.error('Add to cart error:', err);
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
